import { getLocalVar, setLocalVar } from '@/libs/Util.js'

export default {
    state: {
        ACCTERMOSUSOAPP: null,
        useTerm: null,
        userName: getLocalVar('storedUser')?.userName || '',
        NMRESPCONS: null,
        userAccess: null,
        password: '',
        refreshToken: getLocalVar('storedUser')?.refreshToken || '',
        shouldRememberPassword: getLocalVar('storedUser')?.shouldRememberPassword || false,
        dependents: [],
        currentDependent: {},
        recoverPasswordData: {
            CDCLIENTE: '',
            CDCONSUMIDOR: '',
            NMLOGINCONS: '',
            userName: ''
        },
        loginStoreOptions: [],
        selectedLoginOption: null
    },
    mutations: {
        setLoginUsername (state, data) {
            state.userName = data
        },
        setLoginPassword (state, data) {
            state.password = data
        },
        setRefreshToken (state, data) {
            state.refreshToken = data
        },
        setRememberPassword (state, data) {
            state.shouldRememberPassword = data
        },
        setAllUserData (state, data) {
            state.userName = data.userName
            state.NMRESPCONS = data.NMRESPCONS
            state.refreshToken = data.refreshToken
            state.shouldRememberPassword = data.shouldRememberPassword
            setLocalVar('storedUser', {
                userName: data.userName,
                refreshToken: data.refreshToken,
                shouldRememberPassword: data.shouldRememberPassword
            })
        },
        setUserAccess (state, dependents) {
            state.userAccess = dependents
        },
        setDependents (state, dependents) {
            state.dependents = dependents
        },
        setCurrentDependent (state, dependentKey) {
            state.currentDependent = state.dependents[dependentKey]
        },
        toggleCardStatusDep (state, status) {
            const { CDCONSUMIDOR } = state.currentDependent
            const dependentIndex = state.dependents.findIndex((dependent) => dependent.CDCONSUMIDOR === CDCONSUMIDOR)
            state.dependents[dependentIndex].IDSITCONSUMI = status
        },
        toggleCardStatusCDCONS (state, data) {
            const { CDCONSUMIDOR, newStatus } = data
            const dependentIndex = state.dependents.findIndex((dependent) => dependent.CDCONSUMIDOR === CDCONSUMIDOR)
            state.dependents[dependentIndex].IDSITCONSUMI = newStatus
        },
        setRecoverPasswordData (state, data) {
            state.recoverPasswordData = data
        },
        setLoginStoreOptions (state, data) {
            state.loginStoreOptions = data
        },
        setACCTERMOSUSOAPP (state, data) {
            state.ACCTERMOSUSOAPP = data
        },
        setNMRESPCONS (state, data) {
            state.NMRESPCONS = data
        },
        setUseTerm (state, data) {
            state.useTerm = data
        },
        setSelectedLoginOption (state, data) {
            state.selectedLoginOption = data
        }
    },
    actions: {
        setLoginUsername ({ commit }, data) {
            commit('setLoginUsername', data)
        },
        setLoginPassword ({ commit }, data) {
            commit('setLoginPassword', data)
        },
        setRefreshToken ({ commit }, data) {
            commit('setRefreshToken', data)
        },
        setRememberPassword ({ commit }, data) {
            commit('setRememberPassword', data)
        },
        setAllUserData ({ commit }, data) {
            commit('setAllUserData', data)
        },
        setUserAccess ({ commit }, data) {
            commit('setUserAccess', data)
        },
        setDependents ({ commit }, dependents) {
            commit('setDependents', dependents)
        },
        setCurrentDependent ({ commit }, dependentKey) {
            commit('setCurrentDependent', dependentKey)
        },
        toggleCardStatusDep ({ commit }, status) {
            const newStatus = status === '1' ? '2' : '1'
            commit('toggleCardStatusDep', newStatus)
        },
        toggleCardStatusCDCONS ({ commit }, data) {
            commit('toggleCardStatusCDCONS', data)
        },
        setRecoverPasswordData ({ commit }, data) {
            commit('setRecoverPasswordData', data)
        },
        setLoginStoreOptions ({ commit }, data) {
            commit('setLoginStoreOptions', data)
        },
        setACCTERMOSUSOAPP ({ commit }, data) {
            commit('setACCTERMOSUSOAPP', data)
        },
        setNMRESPCONS ({ commit }, data) {
            commit('setNMRESPCONS', data)
        },
        setUseTerm ({ commit }, data) {
            commit('setUseTerm', data)
        },
        setSelectedLoginOption ({ commit }, data) {
            commit('setSelectedLoginOption', data)
        }
    },
    getters: {
        getUseTerm: (state) => state.useTerm,
        getACCTERMOSUSOAPP: (state) => state.ACCTERMOSUSOAPP,
        getNMRESPCONS: (state) => state.NMRESPCONS,
        getUserAccess: (state) => state.userAccess,
        getUsername: (state) => state.userName,
        getPassword: (state) => state.password,
        getrmbpassword: (state) => state.rmbpassword,
        getRefreshToken: (state) => state.refreshToken,
        dependentsList: (state) => (state.dependents || []).concat([{
            IDSITCONSUMI: 'A',
            ICON: 'user-plus'
        }]),
        getCurrDependent: (state) => state.currentDependent,
        getRecoverPasswordData: (state) => state.recoverPasswordData,
        getLoginStoreOptions: (state) => state.loginStoreOptions,
        getSelectedLoginOption: (state) => state.selectedLoginOption
    }
}
